import { TableCell, Typography } from "@mui/material"

export function WeekHeader({ item }) {
    return (
        <TableCell sx={{ whiteSpace: "nowrap", position: "sticky", top: 0 }}>
            <Typography variant="caption">W{`${item + 1}`.padLeft(2, "0")}</Typography>
        </TableCell>
    )
}
